import { Component, Input, OnInit, ViewEncapsulation} from '@angular/core'
//import { DomSanitizer } from '@angular/platform-browser'
import { AppStore, getUserProfile } from '@alfresco/aca-shared/store'
//import { Store } from '@ngrx/store'
import { filter, map, tap } from 'rxjs/operators'
import { BehaviorSubject, combineLatest, Observable } from 'rxjs'
import { Store } from '@ngrx/store'

import { NodeEntry } from '@alfresco/js-api'

@Component({
  selector: 'aca-aev-viewer',
  template: `
    <span *ngIf="srcUrl$ | async | safe as url">
      <iframe [src]="url"></iframe>

      <style>
        iframe {
          flex: 1;
          width: 99vw;
          height: 95vh;
        }
      </style>
    </span>
  `,
   encapsulation: ViewEncapsulation.None,
})
export class EnterpriseViewer implements OnInit  {

  private urlSubject = new BehaviorSubject<string>('');
  srcUrl$!: Observable<any>

  @Input() set url(url: string) {
    this.urlSubject.next(url)
  }

  @Input()
  node!: NodeEntry;

  constructor(public store: Store<AppStore>) {}

  nameFile!: string

  //private store = inject<Store<AppStore>>(Store<AppStore>)

  ngOnInit() {

    //console.log("ngOnInit called", this.node);

    this.srcUrl$ = combineLatest([
      this.store.select(getUserProfile),
      this.urlSubject.asObservable(),
    ]).pipe(
      tap(result => console.log(result)),
      filter(([user, urlStr]) => !!user && !!urlStr),
      map(([user, urlStr]) => {
        console.log("url", urlStr);

        const url = new URL(urlStr)
        console.log("url.origin", url.origin);

        const matches = url.pathname.match(/nodes\/(?<nodeId>.*)\/content/)
        if (!matches) {
          return ''
        }

        const nodeId = matches.groups?.['nodeId']
        const ticket = url.searchParams.get('alf_ticket') || ''

        //console.log("nodeId", nodeId);
        //console.log("ticket", ticket);
        // hack because cloud proxy not working correctly
        //let url2 = new URL("https://carlislehomesdev.alfrescocloud.com")
        let dns = url.origin;
        if(url.hostname != "localhost"){
          //console.log("origin", url2.origin);
          const fqdn = dns
          const { host, domain } = this.splitFQDN(fqdn);
          //console.log(`Host: ${host}, Domain: ${domain}`);

          dns = host + domain;

          console.log(`DNS: ${dns}`);
        }

        // Example usage:


        const iframeUrl = new URL(`${dns}/OpenAnnotate/login/external.htm`)
        // hard coding in value
        //const iframeUrl = new URL(`https://carlislehomesdev-app.alfrescocloud.com/OpenAnnotate/login/external.htm`)

        //console.log("ifrmeUrl", iframeUrl);

        iframeUrl.searchParams.set('docId', `workspace://SpacesStore/${nodeId}`)
        // iframeUrl.searchParams.set('parentId', `workspace://SpacesStore/0eb86736-3e91-49de-9354-2dbe2c45d462`);

        document.cookie = `ocUser=${user.id};path=/`
        document.cookie = `ticket=${ticket};path=/`

        iframeUrl.searchParams.set('ticket', ticket)
        iframeUrl.searchParams.set('username', user.id)

        console.log("iframeUrl", iframeUrl.toString());

        return iframeUrl.toString()

      })
    );
    //.subscribe();

  }

  splitFQDN(fqdn: string): { host: string; domain: string } {
    const parts = fqdn.split('.');

    if (parts.length < 2) {
        //throw new Error('Invalid FQDN');
        return {host: "carlislehomesdev", domain: "alfrescocloud.com"}
    }

    // The host is the first part and the domain is the rest
    const host = parts[0];
    const domain = parts.slice(1).join('.');

    return { host, domain };
}



}
